module.exports = __webpack_public_path__ + "img/career-discovery.27eb4c23.jpg";